import { Check, ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/lib/constants";

const SectionHeader = () => (
    <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 mb-16">
        <div className="lg:col-span-4 reveal">
            <div className="flex items-center gap-3 mb-6">
                <span className="block w-12 h-px bg-[#2E7D5B]" />
                <span className="label-tag">Serviços</span>
            </div>
            <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-black uppercase tracking-tighter leading-[0.95] text-[#0A0A0A]">
                O que <br /> fazemos.
            </h2>
        </div>
        <div className="lg:col-span-7 lg:col-start-6 reveal">
            <p className="text-base md:text-lg text-[#0A0A0A]/60 leading-relaxed font-light">
                Limpeza técnica de elevada exigência para sistemas críticos em
                cozinhas profissionais. Cada intervenção é planeada para
                garantir higiene, segurança e máxima eficiência operacional.
            </p>
        </div>
    </div>
);

const ServiceCard = ({ service }) => (
    <article
        data-testid={`service-card-${service.id}`}
        className="group relative bg-white p-8 md:p-10 reveal hover:bg-[#FAFAFC] transition-colors"
    >
        <div className="flex items-start justify-between mb-8">
            <span className="label-tag">/ {service.number}</span>
            <ArrowUpRight className="w-6 h-6 text-[#0A0A0A]/30 group-hover:text-[#9B2C2C] group-hover:rotate-12 transition-all" />
        </div>

        <h3 className="font-display text-2xl md:text-3xl font-bold uppercase tracking-tight mb-4 leading-tight text-[#0A0A0A]">
            {service.title}
        </h3>
        <p className="text-[#0A0A0A]/60 text-sm leading-relaxed mb-6 font-light">
            {service.short}
        </p>

        <ul className="space-y-2.5">
            {service.bullets.map((b) => (
                <li key={b} className="flex items-start gap-3 text-sm text-[#0A0A0A]/75">
                    <Check className="w-4 h-4 text-[#9B2C2C] mt-0.5 flex-shrink-0" />
                    <span>{b}</span>
                </li>
            ))}
        </ul>

        <span className="absolute bottom-0 left-0 h-px w-0 bg-[#9B2C2C] group-hover:w-full transition-all duration-500" />
    </article>
);

const Services = () => (
    <section
        id="servicos"
        data-testid="services-section"
        className="relative py-24 md:py-32 px-6 md:px-12 lg:px-24 bg-white"
    >
        <div className="max-w-7xl mx-auto">
            <SectionHeader />
            <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-black/10 border border-black/10">
                {SERVICES.map((s) => (
                    <ServiceCard key={s.id} service={s} />
                ))}
            </div>
        </div>
    </section>
);

export default Services;
